import { createRequiredContext } from '@festina-life/ui/libs'

import type { FormatRequest } from './types'

type FPlusFormattedExpressionsProviderProps = {
  requestFormat: (request: FormatRequest) => void
  format: (request: FormatRequest) => string
  formatDirectly: (expressions: string[], width: number) => Promise<string[]>
}

const [useFPlusFormattedExpressionsContext, Provider] =
  createRequiredContext<FPlusFormattedExpressionsProviderProps>(
    'FPlusFormattedExpressions',
  )

export { Provider, useFPlusFormattedExpressionsContext }
